import React, { useEffect, useState } from 'react';
import {useFetch, sortByString} from '@utils'
import { Spin, message, Typography, List } from 'antd';
import { LarpTable } from '@tables';
import getHerbsForRecepy from '../functions/getHerbsForRecepy';
import { PotionRecepyWikiCsv } from './cvs';
import { mapToFilter } from '../../../../utils/functions/filters';
const { Text } = Typography;

export default function PotionRecepyWiki() {
     const [doFetch] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [result, setResult] = useState([])
     const [amountShown, setAmountShown] = useState(0);
     const [listSource, setListSource] = useState([]);

      useEffect(() => {
        if(result.length <= 0) {
          return;
        }
        const newDataSource = result.filter(_ => {
             return _.potion?.item?.name?.toLowerCase().includes(searchValue.toLowerCase())
                || _.herbs?.filter(_ => _.item?.name?.toLowerCase().includes(searchValue.toLocaleLowerCase())).length > 0
        //   || _.id.toString() === searchValue.toString()
        }
        )
        setDataSource(newDataSource);
        setListSource(tableList(newDataSource))
        setAmountShown(newDataSource.length)
      }, [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue])

      function refresh(id)
      {
          const url = `/api/potion/recepiesgetwiki`
          doFetch(url)
          .then((response) => onLoaded(response.isSuccess, response.result))
  
          function onLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);

              return;
            }
            setResult([])
            message.error('Could not get potions');
            setIsLoading(false);
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      const columns = [
        {
          title: 'Id',
          dataIndex: 'id',
          key: 'id',
          hidden: true
        },
        {
          title: 'Potion',
          key: 'potion',            
          render: (record) => {
              return record.potion?.item?.name
            },
          sorter: (a, b) => sortByString(a.potion?.item?.name, b.potion?.item?.name),// a.potion?.item?.name.localCompare(b.potion?.item?.name),
          sortDirections: ['ascend', 'descend', 'ascend'],
          defaultSortOrder: 'ascend'
        },
        {
            title: 'Herbs',
            key: 'herbs',            
            render: (record) => getHerbsForRecepy(record),
            filters: herbfilterFromDatasource(dataSource),
            onFilter: (value, record) => {
              var found = false
              record.herbs.forEach(herb => {
                  if (herb.item.id === value) {
                    found = true
                  }
                }
              )
              return found}
        },
        {
            title: 'Discovered by',
            dataIndex: 'discoverdBy',
            key: 'discoverdBy',
            sorter: (a, b) => sortByString(a.discoverdBy, b.discoverdBy),
            sortDirections: ['ascend', 'descend', 'ascend'],
        }
    ].filter(_ => !_.hidden)

    function onTableChange(pagination, filters, sorter, extra)
    {
      setAmountShown(extra.currentDataSource.length)
    }

    function herbfilterFromDatasource(dataSource) {
      var filter = new Map()
      dataSource.forEach(record => 
        record.herbs.map( herb =>
          filter.set(
            herb.item?.id,
            herb.item?.name
          )
        )
      )
      return mapToFilter(filter)
    }

    return (
      <>

        <Text>{amountShown} of {result.length} recepies shown </Text>
        <LarpTable 
          setSearchValue={setSearchValue}
          refresh={refresh}
          dataSource={dataSource}
          listSource={listSource}
          columns={columns}
          onTableChange={onTableChange}
          csv={PotionRecepyWikiCsv(dataSource)}
        />
      </>
    )
}

export function tableList(  
    list,   
  ) {
    return list.map(_ => {
      return (
              <List.Item
                style={{display:"flex", flexDirection:"column"}}
              >
  
                <List.Item.Meta
                  style={{width:"100%"}}
                  title={_.amountCrafted > 1 ? `${_.amountCrafted} x ${_.potion?.item?.name}` : _.potion?.item?.name}
                  description={`Discovered by: ${_.discoverdBy}`}
                />
                <div className="list-tags">
                  {getHerbsForRecepy(_)}
                </div>
              </List.Item>
      )
    })
  }